import React from 'react';
import { ArrowRight, Star, Zap } from 'lucide-react';

const CTA = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand/20 via-brand-light/20 to-highlight/20"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand/30 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-light/30 rounded-full blur-3xl animate-pulse-slow animation-delay-400"></div>

      <div className="relative z-10 max-w-4xl mx-auto content-padding">
        <div className="bg-dark-surface/90 backdrop-blur-lg border border-dark-border rounded-2xl p-8 md:p-12 text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand/10 border border-brand/30 rounded-full mb-6">
            <Star className="w-4 h-4 text-brand" />
            <span className="text-sm text-brand font-medium">Limited Time Offer</span>
            <Star className="w-4 h-4 text-brand" />
          </div>

          {/* Headline */}
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            Ready to Build Something <span className="brand-gradient">Extraordinary?</span>
          </h2>

          {/* Subheadline */}
          <p className="text-lg text-dark-muted mb-8 max-w-2xl mx-auto">
            Get a free consultation and project estimate. Our experts will help you choose the right technology 
            and approach for your specific needs.
          </p>

          {/* Benefits */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            <div className="flex flex-col items-center">
              <Zap className="w-6 h-6 text-brand mb-2" />
              <span className="text-sm font-medium">Free Consultation</span>
            </div>
            <div className="flex flex-col items-center">
              <Zap className="w-6 h-6 text-brand-light mb-2" />
              <span className="text-sm font-medium">No Obligation</span>
            </div>
            <div className="flex flex-col items-center">
              <Zap className="w-6 h-6 text-highlight mb-2" />
              <span className="text-sm font-medium">Expert Guidance</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="action-btn group flex items-center gap-2"
            >
              Get Started Now
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <a 
              href="mailto:support@hyperionai-ltd.com"
              className="outline-btn"
            >
              Email Us Directly
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-8 pt-8 border-t border-dark-border">
            <p className="text-sm text-dark-muted">
              Trusted by <span className="text-brand font-semibold">200+ companies</span> worldwide • 
              <span className="text-brand font-semibold"> 99% client satisfaction</span> • 
              <span className="text-brand font-semibold"> 10+ years</span> of excellence
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;

